import { render } from "./CreditHistory.vue?vue&type=template&id=fc139cd4&scoped=true"
import script from "./CreditHistory.vue?vue&type=script&lang=js"
export * from "./CreditHistory.vue?vue&type=script&lang=js"

import "./CreditHistory.vue?vue&type=style&index=0&id=fc139cd4&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-fc139cd4"

export default script